<template>
  <div class="steps-section">
    <v-container grid-list-xl pa-0>
      <h2 class="g-title text-transform-none text-xs-center mb-3 mt-0">
        {{ $t('how_works_giver') }}
      </h2>
      <p class="d-flex justify-center px-15 text-center-xs">
        {{ $t('ready_to_get_and_receive') }}
      </p>
      <div class="steps-wrapper mt-5">
        <v-layout row wrap mt-4>
          <v-flex lg4 md4 sm4 xs12>
            <div class="step-block _step-block">
              <div class="icon-wrapper wrapper-1">
                <img src="../../assets/images/icons/man.svg" class="icon" alt="">
              </div>
              <h4 @click="openRegModal" class="cursor-pointer">{{ $t('sign_up') }}</h4>
              <p class="text-for-3-lines">{{ $t('sign_up_for_giver') }}
                <a href="#" @click="openRegModal"> {{ $t('create_giver_account') }}</a>,
                {{ $t('type_your_username_and_password') }}
              </p>
            </div>
          </v-flex>
          <v-flex lg4 md4 sm4 xs12>
            <div class="step-block _step-block">
              <div class="icon-wrapper wrapper-2">
                <img src="../../assets/images/icons/sent.svg" class="icon" alt="">
              </div>
              <h4>{{ $t('confirm_you_registration') }}</h4>
              <p class="text-for-3-lines">{{ $t('check_your_inbox') }}</p>
            </div>
          </v-flex>
          <v-flex lg4 md4 sm4 xs12>
            <div class="step-block no-after _step-block">
              <div class="icon-wrapper wrapper-3">
                <img src="../../assets/images/icons/hand.svg" class="icon" alt="">
              </div>
              <h4>{{ $t('add_your_gift') }}</h4>
              <p class="text-for-3-lines">{{ $t('we_take_care') }}</p>
            </div>
          </v-flex>
          <v-flex lg12 sm12 class="justify-center flex-column-xs text-xs-center">
            <v-btn class="g-middle-btn m-w-220 g-up-letter g-btn-default" @click="$router.push('/donation')">{{ $t('donation.donate')}}</v-btn>
            <v-btn class="g-btn-main g-middle-btn m-w-220 g-up-letter mb-xs-20" @click="openRegModal">{{ $t('add_your_gift_now')}}</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import mainMixins from '../../helpers/_mixins'
import { mapState } from 'vuex'
export default {
  mixins: [ mainMixins ],
  name: 'Steps',
  props: ['loggedUser'],
  watch: {
    'activeLanguage': {
      handler () {
        this.elipsesLoad()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    })
  },
  methods: {
    openRegModal () {
      if (this.loggedUser.id) {
        this.$router.push({name: 'ProfileMyProducts'})
      } else {
        this.$emit('openRegModal')
      }
    },
    elipsesLoad () {
      Array.from(document.querySelectorAll('.steps-section .text-for-3-lines')).forEach(elem => {
        elem.style.maxHeight = '80px'
        setTimeout(() => {
          elem.style.opacity = '1'
        }, 10)
        this.textElipsise(elem)
      })
    }
  },
  mounted () {
    // for cutting very long texts
    setTimeout(() => {
      this.elipsesLoad()
    }, 0)
    window.addEventListener('DOMContentLoaded', () => {
      this.elipsesLoad()
    })
    window.addEventListener('resize', () => {
      this.elipsesLoad()
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/mainPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/welcomePage/Steps.vue